import { Component, effect, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TripCreationModalService } from 'src/app/trip-calculator/services/trip-creation-modal.service';
import { CreationMethodSelectorComponent } from '../creation-method-selector/creation-method-selector.component';
import { TripBasicInfoFormComponent } from '../trip-basic-info-form/trip-basic-info-form.component';
import { ExcelImportComponent } from '../../excel-import/excel-import.component';


@Component({
  selector: 'app-trip-creation-modal',
  imports: [
    ButtonModule,
    DialogModule,
    CreationMethodSelectorComponent,
    TripBasicInfoFormComponent,
    ExcelImportComponent,
  ],
  templateUrl: './trip-creation-modal.component.html',
})
export class TripCreationModalComponent {
  tripCreationModalService = inject(TripCreationModalService);
  visible = false;

  constructor() {
    effect(() => {
      this.visible = this.tripCreationModalService.showTripCreationModal();
    });
  }
  closeModal() {
    this.visible = false;
    this.tripCreationModalService.showTripCreationModal.set(false);
  }
}
